import CircleUserSvg from "@icons/circle-user.svg?react";
import CitySvg from "@icons/city.svg?react";
import { Trans } from "@lingui/react/macro";
import { Link } from "react-router-dom";

import { useCompany } from "@/common/providers/company-provider";
import { useSidebar } from "@/common/providers/sidebar-provider/sidebar-provider";

import { CompanyMenu } from "../company/company-menu/company-menu";
import { NotificationBell } from "../push-notifications/push-notifications";
import { UserMenu } from "../user/user-menu/user-menu";
import { WrapMeWith } from "../wrap-me-with/wrap-me-with";

const UserProfile = () => {
  const { user, company } = useCompany();
  const { actions } = useSidebar();

  if (!user.name) {
    return <Trans>Načítá se</Trans>;
  }

  return (
    <div className="sm-can-top-bar fixed ml-[84px] hidden w-[calc(100%-(--spacing(20)))] justify-end gap-6 bg-white pt-6 pr-6 sm:z-1 sm:flex">
      <NotificationBell />
      <div className="group relative flex gap-2" data-testid="user-profile">
        <CircleUserSvg className="h-6 w-6" />
        <b className="font-can-inter text-can-forest-teal font-bold">
          {user.name}
        </b>
        <div
          className={`invisible absolute right-0 w-[250px] group-hover:visible`}
        >
          <UserMenu.Desktop>
            <UserMenu
              renderItem={{
                plans: (item) => (
                  <Link
                    className="hover:bg-can-silver-gray flex w-full gap-x-4 p-6"
                    to="/pricing"
                  >
                    {item.icon}
                    {item.label}
                  </Link>
                ),
                profile: (item) => (
                  <button
                    className="hover:bg-can-silver-gray flex w-full gap-x-4 p-6 first:rounded-t-2xl"
                    onClick={() => actions.openScreen("user-profile")}
                  >
                    {item.icon}
                    {item.label}
                  </button>
                ),
                subscription: (item) => (
                  <button
                    className="hover:bg-can-silver-gray flex w-full gap-x-4 p-6"
                    onClick={() => actions.openScreen("subscriptions")}
                  >
                    {item.icon}
                    {item.label}
                  </button>
                ),
              }}
            />
          </UserMenu.Desktop>
        </div>
      </div>
      {company ? (
        <span className="h-[26px] border-r border-can-silver-cloud bg-can-forest-teal" />
      ) : null}
      <div
        className={`${user.hasManyCompanies ? "group" : ""} relative flex gap-2`}
        data-testid="company-menu-button"
        role={user.hasManyCompanies ? "button" : undefined}
      >
        {company ? (
          <>
            <WrapMeWith
              when={user.hasManyCompanies}
              wrapper={(children) => (
                <button className="gap-2 flex">{children}</button>
              )}
            >
              <CitySvg className="h-6 w-6" />
              <b className="font-can-inter text-can-forest-teal font-bold">
                {company.name}
              </b>
            </WrapMeWith>
            <div
              className={`invisible absolute right-0 w-[250px] group-hover:visible`}
            >
              <CompanyMenu.Desktop>
                <CompanyMenu />
              </CompanyMenu.Desktop>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export { UserProfile };
